import "./PageButton.css";
import { useNavigate } from "react-router";

function PageButton({ children, page = "/", top = "5px", onClickEffect = "" }) {
  const navigate = useNavigate();
  onClickEffect = onClickEffect === "" ? () => navigate(page) : onClickEffect;
  return (
    <div
      className="page-button-contenair"
      style={{
        marginTop: top,
      }}
    >
      <div className="page-button" onClick={onClickEffect}>
        <div className="page-button-text">{children}</div>
      </div>
    </div>
  );
}

export default PageButton;
